import { GeneralModel } from "./general.model";
import { Customer } from "./customer.model";

export class CustomerPaymentTo extends GeneralModel {
    customerId: number;
    paymentToCustomerId: number;

    customer: Customer;
    paymentToCustomer: Customer;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/customerPaymentTo.model.ts